import $ from 'jquery';
import 'slick-carousel';

let sliderMobile = {
    init() {
        $('.swiper-mobile .list-items').slick({
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows : false,
            infinite: true,
            speed: 300,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 300,
                    settings: "slick",
                },
                {
                    breakpoint: 800,
                    settings: "unslick",
                }
            ]
        })
    }
}

export default sliderMobile;
